export const NotifyMixin = {
  methods: {
    showSuccess(message = '', duration = 0) {
      this.$notify({
        message: message,
        type: 'success',
        duration: duration
      })
    },
    showInfo(message = '', duration = 0) {
      this.$notify({
        message: message,
        type: 'info',
        duration: duration
      })
    },
    showWarn(message = '', duration = 0) {
      this.$notify({
        message: message,
        type: 'warning',
        duration: duration
      })
    },
    showError(message = '', duration = 0) {
      this.$notify({
        message: message,
        type: 'error',
        duration: duration
      })
    },
    getLoading() {
      return this.$loading({
        lock: true,
        text: 'Cargando',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
    },
  }
}
